import {useCookies} from "../../hooks";
import {useState, useEffect} from "preact/compat";
import Cookies from "js-cookie";
import {useUserContext} from "../../contexts";

export const usePopUpAlert = (props) => {
    // Destructured props
    const {rawPathName} = props;

    // State to control whether the modal is open or not
    const [isOpen, setIsOpen] = useState(false);
    // Cookie to check if modal has already been displayed in previous access
    const [shouldDisplayModal, setShouldDisplayModal] = useCookies('popup_modal', true);

    const [{}, {}, {}, {
        ctaPopUp
    }] = useUserContext();

    // Effect to check whether the modal should be displayed or not
    useEffect(() => {
        // Error prevention clause
        if (
            !ctaPopUp ||
            Object.keys(ctaPopUp).length === 0 ||
            ctaPopUp.length === 0
        ) {
            return;
        }

        const hasRegion = Cookies.get("location_modal");

        // Displays the modal after a 2-second delay
        const timer = setTimeout(() => {
            if (
                rawPathName === "/" &&
                (hasRegion && hasRegion === "false") &&
                shouldDisplayModal
            ) {
                setIsOpen(true);
                setShouldDisplayModal(false, 1);

                clearTimeout(timer);
            }
        }, 1500);
    }, [
        ctaPopUp,
        rawPathName,
        shouldDisplayModal,
    ]);

    useEffect(() => {
        if (rawPathName !== "/") {
            setIsOpen(false);
        }
    }, [rawPathName]);

    return {
        isOpen,
        setIsOpen,
        data: ctaPopUp
    }
}
